import React from "react"
import { Button } from '..'

const ReactPagination = (props) => {
  const { 
    theme, totalSize, sizePerPage, currentPage, showFirstLastPages,
    firstPageText, lastPageText, previousPageText, nextPageText,
  } = props
  let pageNum = Math.ceil(totalSize / sizePerPage)

  return (
    <div className={`react-pagination-js-${theme}`} data-test="pagination-container">
          
      {
        showFirstLastPages ?
          <Page {...props} 
            className={currentPage === 1 ? '-secondary pagination-singlebutton page disabled': '-secondary pagination-singlebutton page'}
            label={firstPageText} pageNum={1}/>:
          null
      }
      <Page {...props} 
        className={currentPage === 1 ? '-secondary pagination-singlebutton page disabled': '-secondary pagination-singlebutton page'}
        label={previousPageText} pageNum={currentPage - 1}/>
      <Pagination {...props} pageNum={pageNum}/>
      <Page {...props} 
        className={currentPage === pageNum ? '-secondary pagination-singlebutton page disabled': '-secondary pagination-singlebutton page'}
        label={nextPageText} pageNum={currentPage + 1}/>
      {
        showFirstLastPages ?
          <Page {...props} 
            className={currentPage === pageNum ? '-secondary pagination-singlebutton page disabled': '-secondary pagination-singlebutton page'}
            label={lastPageText} pageNum={pageNum}/> :
          null
      }
    </div>
  )
}

export default ReactPagination

const Pagination = (props) => {
  var { currentPage, numberOfPagesNextToActivePage, pageNum } = props
  let current = currentPage,
    last = pageNum,
    delta = numberOfPagesNextToActivePage,
    left = current - delta,
    right = current + delta + 1,
    range = [],
    rangeWithEllipsis = [],
    l=undefined,
    isEllipsisIncludes = false

  for (let i = 1; i <= last; i++) {
    // eslint-disable-next-line
    if (i === 1 || i === last || i >= left && i < right) {
      range.push(i)
    }
  }

  for (let i of range ) {
            
    if (l && i - l !== 1) {
      rangeWithEllipsis.push(
        <Button key={isEllipsisIncludes ? -1 : 0 }  className={`pagination-numberbutton pageElli`}>
          <a href="/#" className = "anchor-text"> . . .</a>
        </Button>
      )
      isEllipsisIncludes = true
    }
    rangeWithEllipsis.push(
      <Button key={i} 
        className={currentPage === i ? `pagination-numberbutton is-active` : `pagination-numberbutton-nonactive page`}
        onClick={(e) => {e.preventDefault(); props.changeCurrentPage(i)} }>
        <a href="/#" className={currentPage === i ? `pagination-numbercolor is-active anchor-text` : `pagination-numbercolor-nonactive page anchor-text`}>{i}</a>
      </Button>
    )
    l = i
  }
  return rangeWithEllipsis
}

const Page = (props) => {
  const { className, label, pageNum } = props
  return (
    <Button className={className} 
      onClick={() => props.changeCurrentPage(pageNum)}> 
      <a href="/#" className = "anchor-text">
        {label}
      </a> 
    </Button>
  )
}

ReactPagination.defaultProps = {
  theme: "default",
  currentPage: 1,
  totalSize: 10,
  sizePerPage: 10,
  numberOfPagesNextToActivePage: 1,
  showFirstLastPages: false,
  lastPageText: "»",
  firstPageText: "«",
  nextPageText: "⟩",
  previousPageText: "⟨",
}
